/**
 *
 *
 *
 * - 全屏 Loading 显示和隐藏
 *
 *
 */
import { rotatePointSvg } from '@/assets/svg/loading';

const getLoadingBackground = (): string => {
  const isDark = document.documentElement.classList.contains('dark');

  return isDark ? 'rgba(7, 7, 7, 0.85)' : '#fff';
};

const DEFAULT_LOADING_CONFIG = {
  lock: true,
  get background() {
    return getLoadingBackground();
  },
  svg: rotatePointSvg,
  svgViewBox: '0 0 40 40',
  customClass: 'art-loading-fix'
} as const;

interface LoadingInstance {
  close: () => void;
}

let loadingInstance: LoadingInstance | null = null;

export const loadingUtils = {
  /**
   * 显示 loading
   * @returns 关闭 loading 的函数
   */
  showLoading(): () => void {
    if (!loadingInstance) {
      // 每次显示时获取最新的配置，确保背景色与当前主题同步
      const config = {
        ...DEFAULT_LOADING_CONFIG,
        background: getLoadingBackground()
      };

      loadingInstance = ElLoading.service(config);
    }

    return () => this.hideLoading();
  },

  /**
   * 隐藏 loading
   */
  hideLoading(): void {
    if (loadingInstance) {
      loadingInstance.close();
      loadingInstance = null;
    }
  }
};
